import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import PageFilter from "./pageFilter";
import { PageFilterLoaded, PageFilterUpdated } from "./pageFilter.actions";

export class PageFilterReducer extends ReducerBase<PageFilter> {
  constructor() {
    super();

    this.addHandler(PageFilterLoaded.EventName, this.handlePageFilterLoaded)
    this.addHandler(PageFilterUpdated.EventName, this.handlePageFilterUpdated)
  }
  
  handlePageFilterLoaded(
    state: PageFilter = initialState.pageFilter,
    event: PageFilterLoaded
  ): PageFilter {
    return event.pageFilter;
  }
  
  handlePageFilterUpdated(
    state: PageFilter = initialState.pageFilter,
    event: PageFilterUpdated
  ): PageFilter {
    return event.pageFilter;
  }

  handleDefault(state: PageFilter = initialState.pageFilter) {
    return state;
  }
}
